<template>
    <div>
        <b-overlay :show="loading || processingAction" rounded="lg" opacity="0.6">
            <b-card v-if="error" class="text-center m-2">
                <b-alert variant="danger" show class="m-0">
                    <h4>Bir Hata Oluştu</h4>
                    <p class="mb-0">{{ error }}</p>
                </b-alert>
            </b-card>

            <b-card v-else-if="success" class="text-center m-2">
                <b-alert variant="success" show class="m-0">
                    <h4>İşlem Tamamlandı</h4>
                    <p class="mb-0">{{ success }}</p>
                </b-alert>
            </b-card>

            <b-card :title="`Onay Bekleyen Trafik Cezası - ${$safe(details, 'EmployeeFullName') || ''}`" v-else-if="details" class="m-2">
                <traffic-fine-ott-detail :details="details" :processing="processingAction" @approve="approveFine" @reject="openRejectModal" />
            </b-card>
        </b-overlay>

        <b-modal id="ott-reject-modal" title="Trafik Cezası İşlemini Reddet" hide-footer no-close-on-backdrop no-close-on-esc>
            <label for="reject-desc">Lütfen ret nedenini belirtin (zorunlu):</label>
            <b-form-textarea id="reject-desc" v-model="rejectDescription" rows="4" no-resize></b-form-textarea>
            <div class="text-right mt-3">
                <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('ott-reject-modal')">İptal</b-button>
                <b-button variant="danger" @click="rejectFine" :disabled="!rejectDescription || processingAction"> <b-spinner v-if="processingAction" small></b-spinner> Reddet </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BCard, BAlert, BOverlay, BModal, BFormTextarea, BButton, BSpinner } from "bootstrap-vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import TrafficFineOttDetail from "./components/TrafficFineOttDetail.vue";

export default {
    components: {
        BCard,
        BAlert,
        BOverlay,
        BModal,
        BFormTextarea,
        BButton,
        BSpinner,
        TrafficFineOttDetail,
    },
    data() {
        return {
            ott: this.$route.params.q,
            loading: true,
            error: null,
            success: null,
            details: null,
            processingAction: false,
            rejectDescription: "",
        };
    },
    mounted() {
        this.fetchDetails();
    },
    methods: {
        fetchDetails() {
            this.loading = true;
            EmployeeOperationsApi.TrafficFine.GetTaskWithOTT(this.ott)
                .then((res) => {
                    if (res.data.Success) {
                        this.details = res.data.Data;
                    } else {
                        this.error = res.data.Message || "Geçerli bir kayıt bulunamadı veya linkin süresi dolmuş.";
                    }
                })
                .catch((err) => {
                    this.error = "API ile iletişim kurulamadı.";
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        approveFine() {
            this.changeApprovalStatus(true);
        },
        openRejectModal() {
            this.rejectDescription = "";
            this.$bvModal.show("ott-reject-modal");
        },
        rejectFine() {
            if (!this.rejectDescription) return;
            this.changeApprovalStatus(false, this.rejectDescription);
        },
        changeApprovalStatus(approve, description = null) {
            this.processingAction = true;
            if (this.$bvModal) this.$bvModal.hide("ott-reject-modal");

            const payload = { OTT: this.ott, Approve: approve, Description: description };

            EmployeeOperationsApi.TrafficFine.ChangeApprovalStatusWithOTT(payload)
                .then((res) => {
                    this.$result(res);
                    if (!res.data.Success) {
                        this.error = res.data.Message || "İşlem tamamlanamadı. Bu link daha önce kullanılmış olabilir.";
                    } else {
                        this.details = null;
                        this.success = approve ? "İşlem başarıyla onaylandı." : "İşlem başarıyla reddedildi.";
                    }
                })
                .finally(() => {
                    this.processingAction = false;
                });
        },
    },
};
</script>

<style>
.bg-lightest-muted {
    background-color: #f9f9f9 !important;
    border-color: #eaeaea;
    border-style: solid;
    border-width: 1px;
}

.dark-layout .bg-lightest-muted {
    background-color: #3b425365 !important;
    border-color: #434b56;
}
</style>